import ScrollToTopIcon from "@NA/Icons/ScrollToTopIcon";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useEffect, useState } from "react";
import { css } from "styled-components";

interface OwnProps {
    extendedStyles?: ScrollToTopStyles;
}

type Props = OwnProps;

export interface ScrollToTopStyles {
    container?: InjectableCss;
}

export const scrollToTopStylesSection: ScrollToTopStyles = {
    container: {
        css: css`
            position: fixed;
            cursor: pointer;
            bottom: 30px;
            right: 8px;
            z-index: 200;
            svg {
                transform: scale(0.85);
            }
        `,
    },
};

const ScrollToTop = ({
    extendedStyles
}: Props) => {
    const [styles] = useState(() => mergeToNew(scrollToTopStylesSection, extendedStyles));
    const [isVisible, setIsVisible] = useState(false);

    const handleScroll = () => {
        if (typeof window !== undefined) {
            if (window.scrollY > 100) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        }
    };

    const scrollToTop = () => {
        if (typeof window !== undefined) {
            let start = window.scrollY;
            let target = 0;
            let duration = 800;
            let startTime: number = 0;
      
            function animateScroll(currentTime: number) {
              if (!startTime) startTime = currentTime;
              let progress = currentTime - startTime;
              let easeInOutQuad = (progress: number) => progress < 0.5 ? 2 * progress * progress : -1 + (4 - 2 * progress) * progress;
      
              window.scrollTo(0, start + (target - start) * easeInOutQuad(progress / duration));
      
              if (progress < duration) {
                requestAnimationFrame(animateScroll);
              }
            }
            requestAnimationFrame(animateScroll);
        }
    };

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    if (!isVisible) return null;

    return (
        <StyledWrapper {...styles.container} onClick={scrollToTop}>
            <ScrollToTopIcon />
        </StyledWrapper>
    );
};

export default ScrollToTop;
